import React from 'react';
import { notificationSelectors } from '../behaviors/selectors/notification.selectors';
import { notificationActions } from '../behaviors/actions/notification.actions';
import { useAppDispatch, useAppSelector } from '../behaviors';
import { StatusDialog } from './UI.shared';

interface Notification {
  id: number;
  title: string;
  message: string;
  status: string;
}

const UINotifications: React.FC = () => {
  // ------------------------------------------------------------------ State --
  const dispatch = useAppDispatch();

  const notifications = useAppSelector(notificationSelectors.selectNotifications()) as Notification[];

  // REFACTOR: Eventually would like a way to handle multiple notifications at
  // one time using a custom component. For now, only displaying first
  // notification, using the StatusDialog component. The effect will be that if
  // there is > 1 notifications, dismissing/closing the first will cause the
  // next one to be displayed until all notifications have been dismissed/closed.
  const firstNotification = notifications[0];

  // ----------------------------------------------------------------- Events --
  const handleCloseDialog = (notificationId: number) => () => {
    dispatch(notificationActions.dismissNotification(notificationId));
  };

  return (
    <>
      {notifications?.length > 0 && (
        <StatusDialog
          title={firstNotification.title}
          status={firstNotification.status}
          open
          onClose={handleCloseDialog(firstNotification.id)}
        >
          {firstNotification.message}
        </StatusDialog>
      )}
    </>
  );
};

export default UINotifications;
